<template>
  <template v-if="asTooltip">
    <ChannelIcon v-bind:channelType="this.channel.attributes.type" :suffixText="suffixText"
      :customer="customer" :internal="internal" :resolved="resolved" :reopened="reopened" />
  </template>
  <div v-else class="channel-select" :class="{'flex': !noflex, 'current': noflex}">
    <ChannelIcon v-bind:channelType="this.channel.attributes.type" select="true" :inactive="inactive" />
    <span v-if="!iconOnly" class="ml-2 inline-block flex-grow">
      {{channelName}}
    </span>
  </div>
</template>

<script>
import { useFanpagesStore } from '@/stores/fanpages';
import { useVonageStore } from '@/stores/vonageIntegrations';
import ChannelIcon from './ChannelIcon.vue'

export default {
  name: 'ChannelLabel',
  props: ['channel', 'iconOnly', 'noflex', 'asTooltip', 'internal', 'customer', 'resolved', 'reopened', 'inactive'],
  components: {
    ChannelIcon,
  },
  setup() {
    let fanpagesStore = useFanpagesStore();
    let vonageStore = useVonageStore();
    return {
      fanpagesStore, vonageStore,
    };
  },
  computed: {
    channelName() {
      let id = this.channel.attributes.identifier;
      let label = this.channel.attributes.type;
      if (label === 'messenger') {
        let fanpage = this.fanpagesStore.getByFanpageId(id);
        if (fanpage) {
          return fanpage.attributes.name;
        } else {
          return id;
        }
      }
      if (label === 'instagram') {
        let fanpage = this.fanpagesStore.getByFanpageInstagramAccountId(id);
        if (fanpage) {
          return fanpage.attributes['instagram-business-account']['data']['attributes']['name'];
        } else {
          return id;
        }
      }
      if (label === 'whatsapp') {
        let integration = this.vonageStore.getByPhoneNumber(id);
        if (integration) {
          return integration.attributes['name'];
        } else {
          return id;
        }
      }
      return id;
    },
    suffixText() {
      if (this.asTooltip) {
        return this.channelName;
      }
      return '';
    }
  },
}
</script>
